<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="配置状态" prop="configStatus">
                <a-select
                  placeholder="请选择配置状态"
                  v-model="queryParam.configStatus"
                  style="width: 100%"
                  allow-clear
                >
                  <a-select-option v-for="item in onlineOptions" :key="item.dictValue" :value="item.dictValue">
                    {{ item.dictLabel }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="日期" prop="packagedTime">
                <a-range-picker
                  showTime
                  style="width: 100%"
                  v-model="daterangeDeviceTime"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  format="YYYY-MM-DD HH:mm:ss"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 增加修改 -->
      <!-- <create-form ref="createForm" @ok="getList" /> -->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="online" slot-scope="text, record">
          {{ onlineMap[record.online] }}
        </span>
        <span slot="deviceTime" slot-scope="text, record">
          {{ parseTime(record.deviceTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="toConfig(record)"> <a-icon type="edit" />配置 </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getOtaList } from '@/api/device/ota'

export default {
  name: 'DeviceStatus',
  components: {},
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 设备时间时间范围
      daterangeDeviceTime: [],
      // 查询参数
      queryParam: {
        configStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: 'OTA版本号',
          dataIndex: 'otaVersion',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '打包时间',
          dataIndex: 'packagedTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '描述',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '打包人',
          dataIndex: 'packager',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'CPU架构',
          dataIndex: 'cpuArch',
          ellipsis: true,
          customRender: (text, record, index) => {
            const status = record.cpuArch
            if (status === 0) {
              return 'X86'
            } else if (status === 1) {
              return 'ARM'
            } else if (status === -1) {
              return '全部'
            } else {
              return ''
            }
          },
          align: 'center'
        },
        {
          title: '配置状态',
          dataIndex: 'configStatus',
          ellipsis: true,
          customRender: (text, record, index) => {
            const status = record.configStatus
            if (status === 0) {
              return '未配置'
            } else if (status === 1) {
              return '已配置'
            } else {
              return ''
            }
          },
          align: 'center'
        },
        {
          title: 'ARM安装包（M）',
          dataIndex: 'armSize',
          ellipsis: true,
          customRender: (text, record, index) => {
            return (record.armSize / 1024 / 1024).toFixed(2)
          },
          align: 'center'
        },
        {
          title: 'X86安装包（M）',
          dataIndex: 'x86Size',
          ellipsis: true,
          customRender: (text, record, index) => {
            return (record.x86Size / 1024 / 1024).toFixed(2)
          },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      onlineMap: {
        0: '离线',
        1: '在线'
      },
      onlineOptions: [
        { dictValue: '', dictLabel: '全部' },
        { dictValue: '0', dictLabel: '未配置' },
        { dictValue: '1', dictLabel: '已配置' }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询设备状态列表 */
    getList() {
      this.loading = true
      this.queryParam.params = {}
      if (
        this.daterangeDeviceTime !== null &&
        this.daterangeDeviceTime !== '' &&
        this.daterangeDeviceTime.length !== 0
      ) {
        this.queryParam.params['packagedStartTime'] = this.daterangeDeviceTime[0]
        this.queryParam.params['packagedEndTime'] = this.daterangeDeviceTime[1]
      }
      getOtaList(this.queryParam).then((response) => {
        this.list = response.rows
        this.total = response.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.daterangeDeviceTime = []
      this.queryParam = {
        configStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    toConfig(record) {
      this.$router.push({
        path: '/ota/config',
        query: record
      })
    }
  }
}
</script>
